import React, { useState } from 'react';

import {
    TextField,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Box,
    Modal,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';



const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const TransferProjectTesting = ({ open, onClose }) => {
    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily:'Manrope' }}>Transfer project Testing</Typography>
                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box sx={{ m: '0 auto 24px' }}>
                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily:'Manrope' }}>Destination Organization</Typography>
                        <TextField placeholder="Enter a Destination Organization" fullWidth size="small" fontWeight={400}
                            sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily:'Manrope' }} />
                    </Box>
                    <Box>
                        <Box>
                            <Typography fontWeight={'400'} sx={{ fontSize: '14px', color: '#1A1F36', lineHeight: '1', gap: '6px', margin: '0 auto 14px', fontFamily:'Manrope' }} display="flex" alignItems="center">
                                <Tooltip title="All project date will be preserved." arrow placement="top">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon sx={{ fontSize: '14px' }} fontSize="small" />
                                    </button>
                                </Tooltip>All project date will be preserved.
                            </Typography>
                        </Box>
                        <Box>
                            <Typography fontWeight={'400'} sx={{ fontSize: '14px', color: '#1A1F36', lineHeight: '1', gap: '6px', margin: '0 auto 14px', fontFamily:'Manrope' }} display="flex" alignItems="center">
                                <Tooltip title="You can only transfer projects to organizations you own." arrow placement="top">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon sx={{ fontSize: '14px' }} fontSize="small" />
                                    </button>
                                </Tooltip>You can only transfer projects to organizations you own.
                            </Typography>
                        </Box>
                        <Box>
                            <Typography fontWeight={'400'} sx={{ fontSize: '14px', color: '#1A1F36', lineHeight: '1', gap: '6px', margin: '0 auto 14px', fontFamily:'Manrope' }} display="flex" alignItems="center">
                                <Tooltip title="Any project members who don’t belong to the destination organization will be added to that organization" arrow placement="top">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon sx={{ fontSize: '14px' }} fontSize="small" />
                                    </button>
                                </Tooltip>Any project members who don’t belong to the destination organization will be added to that organization
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#1A1F36" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily:'Manrope' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily:'Manrope' }}>
                        Save
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default TransferProjectTesting;
